/**
 * Paramètres publics de vérification des manifestes de mise à jour.
 * Synchroniser via scripts/licence/sync-release-public-key.js.
 */
export const NEXXUS_RELEASE_KEY_ID = 'nexxus-release-1';
export const NEXXUS_RELEASE_ISSUER = 'Nexxus Conseil Releases';
export const NEXXUS_RELEASE_AUDIENCE = 'ga.nexxus.erp.updates';

export const NEXXUS_RELEASE_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAE0FQz9w9OmQWRxX38rs71ltx//vrW
flYJpfNRV5nPlCjRZjOLmoZN5rummj9vSrcY20nNooE1R/rBIh9FePJgJQ==
-----END PUBLIC KEY-----`;
